import { render } from "./ContentsListArea.vue?vue&type=template&id=0c040b90&scoped=true"
import script from "./ContentsListArea.vue?vue&type=script&lang=js"
export * from "./ContentsListArea.vue?vue&type=script&lang=js"

import "./ContentsListArea.vue?vue&type=style&index=0&id=0c040b90&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\xampp\\htdocs\\ui\\2025\\07\\tokyo-shoseki\\r9\\08s_nt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c040b90"]])

export default __exports__